__turbopack_context__.v({
  "appearAnimation": "_509KbG_appearAnimation",
  "replayBtn": "_509KbG_replayBtn",
  "root": "_509KbG_root",
  "videoContainer": "_509KbG_videoContainer",
});
